import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaHome, 
  FaCalendarAlt, 
  FaHistory, 
  FaStar, 
  FaUser,
  FaTruck,
  FaSignOutAlt
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import './Dashboard.css';

const DashboardNav = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const menuItems = [
    { path: '/dashboard', icon: <FaUser />, label: 'Mon profil' },
    { path: '/dashboard/rendezvous', icon: <FaCalendarAlt />, label: 'Prendre rendez-vous' },
    { path: '/dashboard/planning', icon: <FaTruck />, label: 'Mon planning' },
    { path: '/dashboard/historique', icon: <FaHistory />, label: 'Historique' },
    { path: '/dashboard/avis', icon: <FaStar />, label: 'Mes avis' }
  ];

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Erreur lors de la déconnexion', error);
    }
  };

  return (
    <nav className="dashboard-nav-modern">
      <div className="nav-header">
        <h3>Menu</h3>
      </div>
      
      <ul className="nav-menu">
        {menuItems.map(item => (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          </li>
        ))}
        
        <li className="nav-divider"></li>
        
        <li>
          <Link to="/" className="nav-item home-link">
            <span className="nav-icon"><FaHome /></span>
            <span className="nav-label">Retour à l'accueil</span>
          </Link>
        </li>
        
        <li>
          <button onClick={handleLogout} className="nav-item logout-btn">
            <span className="nav-icon"><FaSignOutAlt /></span>
            <span className="nav-label">Déconnexion</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default DashboardNav;